import Button from "../../Components/Button";
import DynamicDropdown from "../../Components/Dropdown/DynamicDropdown";
import { useAppDispatch, useAppSelector } from "../../App/hooks";
import {
  addEditOptionDomainFormValuesChangeHandler,
  setAddEditOptionDomainFormValues,
  setIsOptionDomainAddEditOpen,
  setOptionDomainFlag,
} from "../../Features/OptionDomain/optionDomainSlice";
import { getBaseInstruments } from "../../Requests/Order/tradeTableRequests";
import TextInput from "../../Components/TextInput";
import {
  addOptionDomain,
  editOptionDomain,
  getGroups,
} from "../../Requests/optionDomain";
import { toast } from "react-toastify";
import { useState } from "react";
import { packetErrorHandler } from "../../Utils/requestUtils";
import FullScreenLoading from "../../Components/Loading/FullScreenLoading";
import { IOptionDomainFormValues } from "../../Interfaces/optionDomain";
import { getStepInstruments } from "../../Requests/stepRequests";
import DynamicMultiSelectDropdown from "../../Components/Dropdown/DynamicMultiSelectDropdown";

const AddEdit = () => {
  const formValues = useAppSelector(
    (store) => store.optionDomain.addEditFormValues
  );

  const dispatch = useAppDispatch();
  const [loading, setLoading] = useState(false);

  const changeHandler = (name: string, value: any) => {
    dispatch(addEditOptionDomainFormValuesChangeHandler({ name, value }));
  };

  const getProperFunction = () => {
    if (formValues.id) return editOptionDomain(formValues);
    return addOptionDomain(formValues);
  };

  const clickHandler = () => {
    setLoading(true);
    getProperFunction()
      .then((resp) => {
        if (!resp.data) toast.error(resp.msg);
        else {
          toast.success(resp.msg);
          dispatch(setOptionDomainFlag(true));
          dispatch(setIsOptionDomainAddEditOpen(false));
          dispatch(
            setAddEditOptionDomainFormValues({} as IOptionDomainFormValues)
          );
        }
      })
      .catch(packetErrorHandler)
      .finally(() => setLoading(false));
  };

  return (
    <div className="flex flex-col justify-start items-start !w-56 px-3 py-2 gap-3">
      {loading ? <FullScreenLoading /> : <></>}
      <DynamicDropdown
        dropdown={{
          name: "baseInsId",
          placeholder: "نماد پایه",
          extraLabel: true,
        }}
        onChange={changeHandler}
        getData={getStepInstruments}
        value={formValues.baseInsId}
      />

      <TextInput
        label="نوسان پذیری"
        name="volatility"
        value={formValues.volatility?.toString()}
        onChange={changeHandler}
        kind="percent"
        extraLabel
      />
      <TextInput
        label="بازده نقدی"
        name="dividendYield"
        value={formValues.dividendYield?.toString()}
        onChange={changeHandler}
        kind="percent"
        extraLabel
      />
      <TextInput
        label="حداکثر روز تا سر رسید"
        name="remainingDayMax"
        value={formValues.remainingDayMax?.toString()}
        onChange={changeHandler}
        kind="number"
        extraLabel
      />
      <TextInput
        label="حداقل حجم معامله روز قبل"
        name="minLastTradeVolume"
        value={formValues.minLastTradeVolume?.toString()}
        onChange={changeHandler}
        kind="number"
        extraLabel
      />

      <TextInput
        label="ضریب گرد کردن"
        name="roundingFactor"
        value={formValues.roundingFactor?.toString()}
        onChange={changeHandler}
        kind="priceWithDecimal"
        extraLabel
      />

      <TextInput
        label="میانگین 30 روزه حباب"
        name="avg30Bubble"
        value={formValues.avg30Bubble?.toString()}
        onChange={changeHandler}
        extraLabel
      />

      <TextInput
        label="انحراف معیار 30 روزه حباب"
        name="std30Bubble"
        value={formValues.std30Bubble?.toString()}
        onChange={changeHandler}
        extraLabel
      />

      <DynamicMultiSelectDropdown
        dropdown={{ name: "groupId", placeholder: "گروه", extraLabel: true }}
        getData={getGroups}
        onChange={changeHandler}
        value={formValues.groupId}
      />

      <TextInput
        label="حداقل حباب محاسبه"
        name="minCalculationBubble"
        value={formValues.minCalculationBubble?.toString()}
        onChange={changeHandler}
        extraLabel
      />

      <Button
        text={formValues.id ? "ویرایش" : "ثبت"}
        variant="contained"
        onClick={clickHandler}
      />
    </div>
  );
};

export default AddEdit;
